import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const GrantDetails3 = () => {

	const App = useApp()
	const [tabList, setTabList] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className={`${styles["grant-list"]} padding`}>
					<div className={styles.category}>보조금24 <i className="tag tag-round tag-blue ml_5">90% 적합</i></div>
					<p className={`${styles.title} mt_10`} style={{ fontSize: "1.8rem" }}>근로·자녀장려금</p>
					<div className={`${styles["tag-group"]} mt_10`}>
						<span>#직장가입자</span>
						<span>#대학생</span>
					</div>
					<div className={`${styles.price} mt_20`}><strong>10</strong> 만원</div>
					<div className={`${styles["detail-box"]} mt_20 mb_0`}>
						<ul className="list-item" style={{ fontSize: "1.4rem" }}>
							<li>
								<span>생애주기</span>
								<span>영유아, 아동, 임신출산</span>
							</li>
							<li>
								<span>대상특성</span>
								<span>소년소녀 가장가구</span>
							</li>
							<li>
								<span>장애유형</span>
								<span>지체(전환대상)</span>
							</li>
							<li>
								<span>가구유형</span>
								<span>다문화ㆍ탈북민</span>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div className="shadow">
				<div className="padding">
					<h3>기관정보</h3>
					<ul className="list-item mt_30">
						<li>
							<span>소관부처</span>
							<span>보건복지부 보육사업기획과</span>
						</li>
						<li>
							<span>문의처</span>
							<span>보건복지부 콜센터</span>
						</li>
					</ul>
					<div className="flex-justify_end mt_10">
						<div className={styles["list-btn"]}>고객센터</div>
						<div className={`${styles["list-btn"]} ml_10`}>홈페이지</div>
					</div>
				</div>
			</div>
			<div className="no-scroll pt_30" style={{ overflowX: "auto" }}>
				<ul className="tab-round no-wrap">
					<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>기본정보</li>
					<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>지원내용</li>
					<li onClick={() => setTabList(2)} className={tabList === 2 ? "active" : ""}>신청방법</li>
					<li onClick={() => setTabList(3)} className={tabList === 3 ? "active" : ""}>기타</li>
				</ul>
			</div>
			<div className="padding pt_20">
				<ul className={styles["explain-list"]}>
					<li>
						<div className={styles.title}>서비스 목적</div>
						<ul>
							<li>
								<p>근로자녀장려세제</p>
								<p>- 저소득계층의 빈곤 탈출을 지원하고 사회안전망을 확충하기 위해 도입되었으며, 근로소득 또는 사업소득에 따라 산정된 근로장려금을 환급 형태로 지급하여 저소득 계층의 근로를 유인하고 실질소득을 지원하기 위한 근로연계형 소득지원 제도</p>
							</li>
							<li>
								<p>자녀장려세제</p>
								<p>- 저소득층 가구의 소득 및 부양자녀 수에 따라 자녀 장려금을 세금 환급 형태로 지급하여 근로 및 출산을 장려하는 소득지원 제도(‘15년부터 시행)</p>
							</li>
						</ul>
					</li>
					<li>
						<div className={styles.title}>지원유형</div>
						<p>현금</p>
					</li>
					<li>
						<div className={styles.title}>지원대상</div>
						<p>긴급지원대상자 중 가구구성원이 사망한 경우 사체의 검안,운반,화장 또는 매장 기타 장제조치를 행하는데 필요한 비용 지원</p>
					</li>
					<li>
						<div className={styles.title}>선정기준</div>
						<ul>
							<li>◦ 「농어업·농어촌 및 식품산업 기본법」 및 「농어업경영체 육성 및 지원에 관한 법률」에서 규정한 어업인, 어업법인 및 수산관련 생산자단체</li>
							<li>
								<p>◦ 수산업법」및「내수면 어업법」에 의한 기르는 어업을 경영 중 인자 또는 경영을 하고자 하는 자</p>
								<p>- 「수산업법」 및 「내수면 어업법」에 의한 양식어업(종묘생산어업, 시험어업 포함) 면허․허가(신고)를 필하거나 면허․허가(신고) 예정인 어업인, 생산자단체(수협, 어촌계, 영어조합법인, 협업 등), 유한회사 및 주식회사 등</p>
								<p>* 개별어장을 기준으로 하되, 어촌계 등 생산자단체의 면허일 경우 단일 어장으로 간주(어촌계 등 생산자단체의 면허어장 내에 2인 이상의 지분 또는 행사자 등 경영체가 달라서 전원 동의가 되지 않는 경우에도 각 지분 또는 행사자가 경영하는 시설물에 대하여는 단일어장으로 간주)</p>
							</li>
						</ul>
					</li>
					<li>
						<div className={styles.title}>선정기준</div>
						<p>◦ 어업경영자금 융자 한도내에서(개인 10억, 법인 15억 한도) 농신보 보증 금액 및 개인 신용도 등에 따라 지원</p>
					</li>
					<li>
						<div className={styles.title}>지원내용</div>
						<p>◦ 수산생물의 질병 예방 및 면역력 증강을 위한 백신, 면역증강제 지원</p>
						<p>- 백신 : 국립수산과학원 등으로부터 국가검정을 필한 제품(단일 혼합백신, 수입산 등)</p>
						<p>- 면역증강제 : 국공립 교육, 연구기관 등에서 효과 및 효능이 검증된 제품 (품목허가를 받은 부표 상 약품 설명서에 면역증강의 효능이 기재된 제품)</p>
						<p>- 수산동물예방 백신 사업비는 배정된 예산의 범위 내에서 지자체 자율로 면역증강제를 지원할 수 있음</p>
						<p>- 지원조건 : 국고 30%, 지방비 30%, 자부담 40%</p>
					</li>
					<li>
						<div className={styles.title}>신청방법</div>
						<ul>
							<li>◦ 사업을 희망하는 자는 사업계획을 수립하여 시․군․구 및 지자체 소속 방역 수행기관에 신청(매년 1월 20일까지)</li>
							<li>◦ 시・군・구 및 지자체 소속 방역 수행기관은 직접 사업을 하고자 하거나 사업을 희망하는 사업자가 있는 경우 사업계획을 수립(지방비・자부담 확보 등)하여 시・도에 제출(매년 2월 28일까지)</li>
							<li>◦ 시・도는 사업대상자 적격 여부, 지원내용・조건, 재원조달계획 등 사업의 타당성을 검토하고, 그 결과를 토대로 추천 우선순위를 정하여 시・도 단위 사업계획을 수립하여 해양수산부에 사업수요 제출(매년 3월 31일까지)</li>
						</ul>
					</li>
					<li>
						<div className={styles.title}>신청기한</div>
						<p>상반기와 하반기 각 두차례 접수기한 내 신청 (접수기관에 문의)</p>
					</li>
					<li>
						<div className={styles.title}>구비서류</div>
						<p>신청서, 사업제안서, 정보제공 및 공개 동의서, 법인 등기사항증명서, 사업자등록증, 제무제표 등</p>
					</li>
					<li>
						<div className={styles.title}>법령</div>
						<p>외국인 종합안내센터 설치 및 운영에 관한 규정</p>
					</li>
				</ul>
			</div>
		</div>
	)
}

export default GrantDetails3
